
import Vue from 'vue';
import Component from 'vue-class-component';
@Component({
  name: 'upgrade-link',
  props: ['trailAltText', 'type']
})
export default class UpgradeLink extends Vue {
  private type!: any;

  get workspace() {
    return this.$user.workspace;
  }

  get variant() {
    return !!this.type ? this.type : 'action';
  }

  get canShowTrial() {
    return this.workspace && !this.workspace.trialEnd;
  }
}
